import {
  FrequencyUnit,
  PlannedOccurrence,
  ScheduleEntryState,
} from './habit-schedule';
import { Timestamp } from './timestamp';

export enum UpcomingPeriodTypes {
  Overdue = 'overdue',
}

export type DayEntry = PlannedOccurrence & {
  isGeneratedFrequencyEntry: boolean;
  isUnplannedEntry: boolean;
  state?: ScheduleEntryState;
  hidden?: boolean;
};

export type UpcomingPeriodDay = {
  date: Timestamp;
  entry?: DayEntry;
};

export type UpcomingPeriod = {
  date: Timestamp;
  days: UpcomingPeriodDay[];
  type: FrequencyUnit | UpcomingPeriodTypes;
};
